import { LockIcon } from 'src/icons/Lock.icon';
import { UpgradeTooltip } from '../Payments/UpgradeTooltip';

const AuraEvidenceSourceTooltip = ({
  showLinkedEvidenceTooltip,
  linkedEvidenceTooltipPosition,
  isEncountersNoteHistoryEnabled,
  showEvidenceForSelectedText,
  resetLinkedEvidenceTooltip,
}) => {
  if (!showLinkedEvidenceTooltip) {
    return null;
  }

  return (
    <div
      className="shadow-lg linked-evidence-float-button bg-[#f5f5f5] font-normal px-4 py-3 rounded-xl focus:outline-none focus:shadow-outline z-50"
      style={{
        position: 'fixed',
        left: `${linkedEvidenceTooltipPosition?.x - 20}px`,
        top: `${linkedEvidenceTooltipPosition?.y + 10}px`,
        width: 300,
      }}
    >
      {isEncountersNoteHistoryEnabled ? (
        <>
          <p className="font-semibold text-md text-[#49454F] mb-2">
            Source Finder
          </p>
          <p className="text-[#49454F] mb-2">
            Highlight text in the summary and click 'Show Source’ to view the
            matching section in the transcription.
          </p>
          <div className="flex items-center">
            <button
              className="show-source-action text-[#00D090] font-semibold"
              onClick={showEvidenceForSelectedText}
            >
              Show Source
            </button>
            <button
              className="show-source-action ml-4 text-[#49454F] font-semibold"
              onClick={resetLinkedEvidenceTooltip}
            >
              Cancel
            </button>
          </div>
        </>
      ) : (
        <div className="flex items-center text-gray-500 cursor-not-allowed">
          <UpgradeTooltip>
            <p className="font-semibold text-md text-[#49454F] mb-2">
              Source Finder
            </p>
            <p className="text-[#49454F] mb-2">
              Highlight text in the summary and click 'Show Source’ to view the
              matching section in the transcription.
            </p>
            <div className="flex items-center">
              <LockIcon />
              <button className="show-source-action text-[#00D090] font-semibold ml-1">
                Show Source
              </button>
              <button
                className="show-source-action ml-4 text-[#49454F] font-semibold"
                onClick={resetLinkedEvidenceTooltip}
              >
                Cancel
              </button>
            </div>
          </UpgradeTooltip>
        </div>
      )}
    </div>
  );
};

export default AuraEvidenceSourceTooltip;
